import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getCoupons } from '../../../api/coupons';

const useCoupons = (options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>) => {
  return useQuery({
    queryKey: ['coupons'],
    queryFn: getCoupons,
    ...options,
  });
};

export default useCoupons;
